const locale = require('./documentBuilder.i18n.json');

/*@ngInject*/
const DocumentBuilderModalController = function ($rootScope, $scope, $window, attachmentUtil, proposal, currentSectionType, sectionType, proposalMediator, attachmentMediator, mimeType, coreConstant) {

    $scope.i18n = locale;
    $scope.viewModel = {
        stitchableSections: [],
        additionalSections: [],
        attachmentName: null,
        proposal: proposal,
        sectionHeaderText: null,
        previewActive: true,
        sendButton: _.get($scope.i18n, 'send'),
        closeButton: _.get($scope.i18n, 'close')
    };

    $scope.sortOptions = {
        orderChanged: function (event) {
            var destinationSection = $scope.viewModel.stitchableSections[event.dest.index],
                sourceSection,
                dropIndex = event.dest.index;
            if (event.dest.index < event.source.index) {
                dropIndex++;
            } else {
                dropIndex--;
            }
            sourceSection = $scope.viewModel.stitchableSections[dropIndex];
            proposalMediator.moveSection(destinationSection.id, sourceSection.proposalOrdinalNumber).then(getSections);
        },
        containment: '#sortContainer',
        containerPositioning: 'relative'
    };

    $scope.updateSection = function (section, stitchable) {
        _.remove($scope.viewModel.stitchableSections, {'id': section.id});
        _.remove($scope.viewModel.additionalSections, {'id': section.id});
        proposalMediator.updateSection(section.id, stitchable).then(getSections);
    };

    $scope.onPreviewClick = function () {
        $scope.viewModel.previewActive = true;
        clearSelectedSections();
        proposalMediator.stitchSections(proposal.id, currentSectionType).then(function (result) {
            $scope.viewModel.attachmentName = result[0].name;
            $scope.viewModel.previewAttachmentId = result[0].id;
        });
    };

    $scope.displayPreview = function () {
        $scope.viewModel.previewActive = true;
        proposalMediator.stitchSections(proposal.id, currentSectionType).then(function (result) {
            $scope.viewModel.attachmentName = result[0].name;
            $scope.viewModel.previewAttachmentId = result[0].id;
            getSections();
        });
    };

    $scope.onSectionPreview = function (section) {
        var isPdf = section.attachmentMimeType === mimeType.PDF;
        if (isPdf) {
            clearSelectedSections();
            $scope.viewModel.attachmentMimeType = section.attachmentMimeType;
            $scope.viewModel.attachmentName = section.description;
            section.selected = true;
            $scope.viewModel.previewAttachmentId = section.attachmentId;
            $scope.viewModel.previewActive = false;
        } else {
            attachmentMediator.retrieveAttachment(section.attachmentId).then(function (result) {
                var attachmentName = result.Attachment.name;
                attachmentUtil.getAttachmentLinkURL(section.attachmentId, attachmentName).then((url) => {
                    $window.open(url, '_blank');
                });
            });
        }
    };

    $scope.allowStitch = function (section) {
        var attachmentMimeType = section.attachmentMimeType;
        return _.isNil(attachmentMimeType) || attachmentMimeType === mimeType.PDF;
    };

    function clearSelectedSections() {
        _.each($scope.viewModel.stitchableSections, function (section) {
            section.selected = false;
        });
        _.each($scope.viewModel.additionalSections, function (section) {
            section.selected = false;
        });
    }

    function getSections() {
        proposalMediator.getSections(proposal.id).then(function (result) {
            $scope.viewModel.stitchableSections = _.filter(result, function (section) {
                return section.stitchable && section.type === currentSectionType;
            });
            $scope.viewModel.additionalSections = _.filter(result, function (section) {
                return !section.stitchable && section.type === currentSectionType;
            });
        });
    }

    function init() {
        $scope.isInModal = true;
        var sectionTextKey;
        if (currentSectionType === sectionType.BINDER) {
            sectionTextKey = 'binderSection';
        } else {
            sectionTextKey = 'proposalSection';
        }

        $scope.displayPreview();
        $scope.viewModel.sectionHeaderText = _.get($scope.i18n, sectionTextKey);
    }

    $scope.canEnableConfirmButton = function () {
        return true;
    };

    $scope.onConfirm = function () {
        $scope.$close();
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    init();

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('documentBuilderModalController', DocumentBuilderModalController);
